import {Icon} from '@trlogic/ui-pack';
import React from 'react';
import LanguageUtil from "../../../../util/LanguageUtil";
import FormicaToggleSwitch from "../../../../components/custom/FormicaToggleSwitch";
import {WatchlistListsEditorModel} from "../../../../domain/cra/CraDomains";

interface Props {
  watchlistResponse: WatchlistListsEditorModel[];
  onToggle: (id: string, value: boolean) => void;
}

function SourceListComponent({watchlistResponse, onToggle}: Props) {

  const getList = () => {
    if (watchlistResponse && watchlistResponse.length > 0) {
      return watchlistResponse
    }
  }

  const list = getList();
  if (!list || list.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={"bg-[#F2F4F7] w-full h-full rounded py-2 px-4 mt-10 flex items-center justify-between cursor-pointer"}>
        <span className={"text-f-black-2 text-md"}>
          {LanguageUtil.get({id: "common.label.lists", defaultMessage: "Lists"})}
        </span>
      </div>
      <div className={"h-full w-full pt-2"}>
        {list.map((data, index) => {
          return (
            <div className={"flex gap-x-2 p-2 border-b border-b-[0.5px]"} key={index}>
              <div className={"w-[20px]"}><Icon icon={"kyc_sourcesicon"} color={"#607080"} size={16}/></div>
              <div className={"w-full h-full flex justify-between gap-y-1 text-md text-[11px] text-[#607080]"}>
                <div className={"flex flex-col gap-y-1"}>
                  <span className={"text-f-black-2"}>{data?.name}</span>
                  <span className={"text-[#458EF7] cursor-pointer"}
                        onClick={() => window.open(data?.authorityWebsite, "_blank")}>
                      {data?.authority}
                    </span>
                </div>
                <div className={"flex gap-x-2 items-center"}>
                    <span
                      className={"flex items-center gap-x-1 text-md min-w-[88px] justify-center text-[#5925DC] bg-[#F4F3FF] rounded-xl px-[8px] py-[3px]"}>
                      <Icon icon={"kyc_namesicon"} size={16}/>{data?.size}
                    </span>
                  <span
                    className={"flex text-md min-w-[88px] justify-center text-[#4F4F4F] bg-[#F2F4F7] rounded-xl px-[8px] py-[3px]"}>{data?.country}</span>
                  <img src={`/country/${data?.country}.svg`} className={"w-[20px] h-[20px]"} alt="country"/>
                  <Icon icon={"link"} size={16} color={"#458EF7"} className={"cursor-pointer"}
                        onClick={() => window.open(data.authorityWebsite, "_blank")}/>
                  <FormicaToggleSwitch onChange={() => onToggle(data.id, !data.isEnabled)} value={data.isEnabled}/>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default SourceListComponent;
